__turbopack_context__.v({
  "tab": "TabTitleRender-module__KY830q__tab",
});
